import { render, staticRenderFns } from "./ChallengeModeCourseCpnt.vue?vue&type=template&id=bf1796b2&"
import script from "@/scripts/MainMode/MainModeCourse/MainModeCourseCpnt/ChallengeModeCpnt/index.js?vue&type=script&lang=js&"
export * from "@/scripts/MainMode/MainModeCourse/MainModeCourseCpnt/ChallengeModeCpnt/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports